const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmailAddress = (value: string): boolean =>
  EMAIL_SHAPE.test(value);

export const INVALID_EMAIL_MESSAGE =
  'Enter a full email address, like name@example.com.';
